import React, { useEffect } from 'react';
import { useBoolean } from '@wegroup/design-system';
import AdvisoryFlowLoading from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryFlowLoading';
import useUuid from '../../../../common/src/hooks/useUuid';
import useStartShortCheckupCompanyFlow from '../../../../risk-analysis/src/hooks/useStartShortCheckupCompanyFlow';
import useQueryParams from '../../../../common/src/hooks/useQueryParams';
import { useParty } from '../../../../parties/src/features/detail/api/getParty';
import NoCbeModal from '../../../../company-scan/features/welcome/components/modals/NoCbeModal';
import { CompanyRegistration } from '../../../../parties/src/types';
import { useTranslation } from 'react-i18next';

const CompanyCheckup: React.FC = () => {
  const { t } = useTranslation();
  const uuid = useUuid();
  const queryParams = useQueryParams();
  const startFlow = useStartShortCheckupCompanyFlow();
  const partyId = queryParams.get('party_id') || undefined;
  const { data: partyData, isLoading, isSuccess } = useParty(partyId);
  const [showCbeInput, setShowCbeInput] = useBoolean();

  useEffect(() => {
    if (!partyId) {
      startFlow(uuid);
    }
  }, []);

  useEffect(() => {
    if (partyData && isSuccess) {
      if (partyData.company_registration?.nr) {
        startFlow(uuid);
      } else {
        setShowCbeInput.on();
      }
    }
  }, [partyData]);

  const handleOnNext = (companyRegistration?: CompanyRegistration) => {
    startFlow(uuid, undefined, partyId, undefined, companyRegistration);
  };

  if (isLoading || !partyId || !showCbeInput) {
    return <AdvisoryFlowLoading />;
  }

  return (
    <NoCbeModal
      partyId={partyId}
      isOpen
      handleOnNext={handleOnNext}
      description={t('COMPANY-QUICKSCAN_CBE-LOOKUP_RESULT_NO-CBE', {
        companyName: partyData?.name,
      })}
    />
  );
};

export default CompanyCheckup;
